<div id="orEmergencyLightingSchedules">
  <app-emergency-lighting-schedules-list [building$]="building$" [tags$]="tags$"></app-emergency-lighting-schedules-list>
</div>
